import type { LayoutContext } from "./_types";

import { createContext, useContext } from "react";

export const Context = createContext({} as LayoutContext);

export const useLayoutContext = () => useContext(Context);
